import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';
import { LanguageSelect, useLocale } from '../../locale';

const WORKS = [
  {
    id: 'isis-episode-1',
    title: '납치 위기의 성녀 AI, 구한 방법이 논란이 되다 ─ 이지스 1화',
    tagline: '전조 INDEX가 공개한 AI 애니메이션 시리즈의 첫 번째 이야기',
    genre: 'AI 애니메이션',
    year: 2026,
    rank: null,
    score: null,
    recommended: true,
    author: '전조 INDEX',
    url: 'https://www.youtube.com/watch?v=upuTXgd56fY',
    thumbnail: 'https://i.ytimg.com/vi/upuTXgd56fY/hqdefault.jpg',
    colors: ['#273d70', '#5c2b68'],
  },
  {
    id: 'saju-episode-2',
    title: '사주팔자 EP.2 〈역명〉',
    tagline: '뒤바뀐 운명, 죽음이 따라오기 시작했다',
    genre: 'AI 판타지 드라마',
    year: 2026,
    rank: null,
    score: null,
    recommended: true,
    author: '밤비부',
    url: 'https://www.youtube.com/watch?v=C0UH77z_t_o',
    thumbnail: 'https://i.ytimg.com/vi/C0UH77z_t_o/hqdefault.jpg',
    colors: ['#49325e', '#1a5066'],
  },
  {
    id: 'gloria-fantasia-ep1-4',
    title: '글로리아 판타지아(Gloria Fantasia) EP1~4',
    tagline: '아직도 안 본 사람 있어? AI 판타지 시리즈 모아보기',
    genre: 'AI 판타지',
    year: 2026,
    rank: null,
    score: null,
    recommended: true,
    author: '뚤라셀',
    url: 'https://www.youtube.com/watch?v=oIVa5mHf4QU&t=1230s',
    thumbnail: 'https://i.ytimg.com/vi/oIVa5mHf4QU/hqdefault.jpg',
    colors: ['#6b335f', '#274e83'],
  },
  {
    id: 'developer-in-another-world-ep1',
    title: '이세계로 간 개발자 EP01: 두 개의 달이 뜨는 곳',
    tagline: '두 개의 달이 뜨는 이세계에서 시작된 개발자의 새로운 이야기',
    genre: 'AI 판타지 드라마',
    year: 2026,
    rank: null,
    score: null,
    recommended: false,
    author: 'CODE:ARCANA',
    url: 'https://www.youtube.com/watch?v=YUe4UmJaqDI',
    thumbnail: 'https://i.ytimg.com/vi/YUe4UmJaqDI/hqdefault.jpg',
    colors: ['#2e4675', '#664068'],
  },
  {
    id: 'orkan-episode-5',
    title: '잠깐만요, 저 아직 이세계 초보인데요 | ORKAN EP.05 〈시련〉',
    tagline: '낯선 이세계의 시련 앞에 선 초보 모험가의 다섯 번째 이야기',
    genre: 'AI 판타지 드라마',
    year: 2026,
    rank: null,
    score: null,
    recommended: false,
    author: '우주씨 · WOOJUICY',
    url: 'https://www.youtube.com/watch?v=fohNQJMBZRk',
    thumbnail: 'https://i.ytimg.com/vi/fohNQJMBZRk/hqdefault.jpg',
    colors: ['#344672', '#6d3b59'],
  },
  {
    id: 'my-dear-orc-episode-1',
    title: '나의 오크(My Dear, Orc) 1화 | 아니… 갑자기 여긴 어디야?!',
    tagline: '갑자기 낯선 세계에 떨어진 주인공과 오크의 첫 번째 이야기',
    genre: 'AI 판타지 드라마',
    year: 2026,
    rank: null,
    score: null,
    recommended: false,
    author: 'Odd Lab 오드랩',
    url: 'https://www.youtube.com/watch?v=1wkoJIxmwzU',
    thumbnail: 'https://i.ytimg.com/vi/1wkoJIxmwzU/hqdefault.jpg',
    colors: ['#31516c', '#703d5a'],
  },
  {
    id: 'dokkaebi-demon-slayers-trial',
    title: '도깨비 힘을 시험하다｜힘을 시험하는 자들｜도깨비 해결사',
    tagline: '태강과 월령의 힘과 각오를 확인하기 위해 백야와 홍연이 벌이는 시험',
    genre: 'AI 판타지 드라마',
    year: 2026,
    rank: null,
    score: null,
    recommended: false,
    author: 'JAYFRAME STUDIO',
    url: 'https://www.youtube.com/watch?v=hxyiMK2wVLk',
    thumbnail: 'https://i.ytimg.com/vi/hxyiMK2wVLk/maxresdefault.jpg',
    colors: ['#273f68', '#63364f'],
  },
  {
    id: 'blade-line-episode-4',
    title: 'BLADE LINE EP.04 히어로 실격 (통합본)',
    tagline: '특수이형섬멸대 BLADE의 네 번째 AI 시네마틱 액션 이야기',
    genre: 'AI 액션 드라마',
    year: 2026,
    rank: null,
    score: null,
    recommended: false,
    author: 'Kidultchar AI Studio | 키덜트샤아',
    url: 'https://www.youtube.com/watch?v=IE62b-tp_kI&t=93s',
    thumbnail: 'https://i.ytimg.com/vi/IE62b-tp_kI/maxresdefault.jpg',
    colors: ['#20365d', '#6a3048'],
  },
  {
    id: 'yawolrok-final-episode',
    title: '야월록: 최종화 | 마지막 봉인, 그리고 남겨진 자들',
    tagline: '왕의 힘을 받아들인 난이만을 봉인하기 위한 소월의 마지막 의식',
    genre: 'AI 판타지 드라마',
    year: 2026,
    rank: null,
    score: null,
    recommended: false,
    author: 'MAVEN스튜디오',
    url: 'https://www.youtube.com/watch?v=PgYqt28PeLU',
    thumbnail: 'https://i.ytimg.com/vi/PgYqt28PeLU/maxresdefault.jpg',
    colors: ['#1d2f55', '#5e2f4e'],
  },
  {
    id: 'triple-world-murim-chapter-2',
    title: '삼중세계 2장 무림편 · 사부와 제자 1~6화 몰아보기',
    tagline: '사부와 제자의 여정을 한 번에 만나는 삼중세계 무림편',
    genre: 'AI 무협 드라마',
    year: 2026,
    rank: null,
    score: null,
    recommended: false,
    author: '삼중세계',
    url: 'https://www.youtube.com/watch?v=bvUOg6tIgpY',
    thumbnail: 'https://i.ytimg.com/vi/bvUOg6tIgpY/maxresdefault.jpg',
    colors: ['#273f58', '#70452f'],
  },
  {
    id: 'red-moon-episodes-1-8',
    title: '60분 순삭 몰아보기｜붉은 달이 뜬 뒤 세상이 무너졌다｜RED MOON EP.1~8 몰아보',
    tagline: '붉은 달이 뜬 뒤 무너진 세상을 그린 RED MOON 1~8화 모음',
    genre: 'AI 판타지 드라마',
    year: 2026,
    rank: null,
    score: null,
    recommended: false,
    author: '붉은달(RedMoon)',
    url: 'https://www.youtube.com/watch?v=--YuxB9ac7o',
    thumbnail: 'https://i.ytimg.com/vi/--YuxB9ac7o/maxresdefault.jpg',
    colors: ['#4d1724', '#772e42'],
  },
  {
    id: 'desert-island-survival-episodes-10-20',
    title: '[10~20화 몰아보기] 날 쫓아낸 걸 후회하게 될 거야 | 무인도 생존기',
    tagline: '무인도에서 펼쳐지는 생존과 반격의 10~20화 연속 이야기',
    genre: 'AI 생존 드라마',
    year: 2026,
    rank: null,
    score: null,
    recommended: false,
    author: '에이아이드라마',
    url: 'https://www.youtube.com/watch?v=bBTUk4J8Y0c',
    thumbnail: 'https://i.ytimg.com/vi/bBTUk4J8Y0c/maxresdefault.jpg',
    colors: ['#3f4f38', '#80613d'],
  },
  {
    id: 'vantaire-extra-series-2026',
    title: 'VANTAIRE | EXTRA SERIES [Ai] (2026)',
    tagline: 'VANTAIRE 세계관을 확장하는 2026 AI 시네마틱 시리즈',
    genre: 'AI SF',
    year: 2026,
    rank: null,
    score: null,
    recommended: false,
    author: 'VM_AIGC',
    url: 'https://www.youtube.com/watch?v=V49poyfRo8Y',
    thumbnail: 'https://i.ytimg.com/vi/V49poyfRo8Y/hqdefault.jpg',
    colors: ['#27374f', '#59405f'],
  },
  { id: 'orbit', title: '궤도 밖의 편지', tagline: '기억을 배달하는 우체국의 마지막 밤', genre: 'SF', year: 2026, rank: 1, score: 9.8, recommended: true, colors: ['#356cff', '#6946df'] },
  { id: 'echo', title: '에코 시티', tagline: '사라진 목소리가 도시를 다시 움직인다', genre: '미스터리', year: 2026, rank: 2, score: 9.6, recommended: true, colors: ['#26b98c', '#2387d9'] },
  { id: 'minute', title: '마지막 5분', tagline: '시간이 멈춘 플랫폼에서 시작된 선택', genre: '드라마', year: 2026, rank: 3, score: 9.3, recommended: true, colors: ['#ffb34c', '#ff716f'] },
  { id: 'blue', title: '푸른 잔상', tagline: '꿈을 복원하는 화가와 잊힌 얼굴', genre: '판타지', year: 2026, rank: 4, score: 9.1, colors: ['#2c7cff', '#33c7c4'] },
  { id: 'signal', title: '제로 시그널', tagline: '신호가 끊긴 뒤에야 들려온 진실', genre: '스릴러', year: 2025, rank: 5, score: 8.9, colors: ['#ff5f75', '#9d4edd'] },
  { id: 'room', title: '작은 우주', tagline: '하나의 방에서 펼쳐지는 여섯 개의 세계', genre: '드라마', year: 2026, rank: 6, score: 8.7, colors: ['#5b55ff', '#2f76ff'] },
  { id: 'paper', title: '종이 달', tagline: '접힌 밤하늘을 펴는 아이들의 여행', genre: '애니메이션', year: 2026, rank: 7, score: 8.6, colors: ['#00a7a0', '#83c25a'] },
  { id: 'memory', title: '메모리 마켓', tagline: '기억을 사고파는 시장의 정체', genre: 'SF', year: 2025, rank: 8, score: 8.4, colors: ['#8c54d8', '#d94f83'] },
];

const gradient = (work) => `linear-gradient(140deg, ${work.colors[0]}, ${work.colors[1]})`;
const artStyle = (work) => (work.thumbnail ? {
  backgroundImage: `linear-gradient(90deg, rgba(4,10,20,.42), rgba(4,10,20,.12)), url("${work.thumbnail}")`,
  backgroundPosition: 'center',
  backgroundSize: 'cover',
} : { background: gradient(work) });

export default function Drama() {
  const { t } = useLocale();
  // Only these app-owned categories are keys; artwork metadata remains original content.
  const genreLabel = name => ['전체', 'AI 애니메이션', 'AI 판타지 드라마', 'AI 판타지', 'AI 액션 드라마', 'AI 무협 드라마', 'AI 생존 드라마', 'AI SF', 'SF', '미스터리', '드라마', '판타지', '스릴러', '애니메이션'].includes(name) ? t(name) : name;
  const [genre, setGenre] = useState('전체');
  const [query, setQuery] = useState('');
  const [selected, setSelected] = useState(null);
  const genres = ['전체', ...Array.from(new Set(WORKS.map((work) => work.genre)))];
  const filtered = useMemo(() => {
    const needle = query.trim().toLowerCase();
    return WORKS.filter((work) => (genre === '전체' || work.genre === genre)
      && (!needle || `${work.title} ${work.tagline} ${work.genre} ${work.author || ''}`.toLowerCase().includes(needle)));
  }, [genre, query]);
  const featured = filtered[0] || WORKS[0];
  const recommended = filtered.filter((work) => work.recommended).slice(0, 3);
  // 순위는 실제 공개된 작품(영상 링크가 있는 것)만 담고, 보이는 자리마다
  // 1부터 다시 번호를 붙인다. 전에는 작품 데이터의 rank 값을 그대로 썼는데
  // 공개작은 전부 rank 가 비어 있어서 순위에 한 편도 들어가지 못했다.
  const ranked = useMemo(() => filtered
    .filter((work) => work.url)
    .slice(0, 10)
    .map((work, index) => ({ ...work, rank: index + 1 })), [filtered]);

  return (
    <Page>
      <GlobalReset />
      <Header>
        <Brand to="/"><Mark>A</Mark><BrandCopy><b>Ants Cast</b><span>{t('AI 작품관')}</span></BrandCopy></Brand>
        <Nav><Active to="/drama">{t('AI 작품관')}</Active><NavLink to="/">{t('앤츠미팅')}</NavLink><NavLink to="/meet">{t('회의 시작')}</NavLink></Nav>
        <LanguageSelect />
      </Header>

      <Main>
        <Hero style={artStyle(featured)}>
          <HeroGlow />
          <HeroContent>
            <Badge>{t('✦ 이번 주 추천작')}</Badge>
            <HeroTitle>{featured.title}</HeroTitle>
            <HeroText>{featured.tagline}</HeroText>
            <Meta><span>{featured.year}</span><span>{genreLabel(featured.genre)}</span>{featured.author ? <span>{featured.author}</span> : null}{featured.score ? <span>★ {featured.score}</span> : null}</Meta>
            <HeroButtons>
              <Primary type="button" onClick={() => setSelected(featured)}>{t('작품 정보')}</Primary>
              {featured.url ? <Secondary as="a" href={featured.url} target="_blank" rel="noreferrer">{t('YouTube에서 보기 ↗')}</Secondary> : <Secondary type="button">{t('공개 예정')}</Secondary>}
            </HeroButtons>
          </HeroContent>
        </Hero>

        <Toolbar>
          <Search value={query} onChange={(event) => setQuery(event.target.value)} aria-label={t('작품명, 장르로 검색')} placeholder={t('작품명, 장르로 검색')} />
          <Genres>{genres.map((name) => <Chip type="button" key={name} $active={genre === name} aria-pressed={genre === name} onClick={() => setGenre(name)}>{genreLabel(name)}</Chip>)}</Genres>
        </Toolbar>

        <Curation>
          <SectionHead><div><H2>{t('AI 작품 큐레이션')}</H2><Sub>{t('에디터 추천과 지금 주목받는 작품을 한눈에 만나보세요.')}</Sub></div><CurationMark>✦</CurationMark></SectionHead>
          <CurationGrid>
            <Recommend>
              <SmallTitle>{t('☆ 당신을 위한 추천')}</SmallTitle><SmallSub>{t('앤츠캐스트가 고른 AI 창작물')}</SmallSub>
              <RecommendGrid>
                {(recommended.length ? recommended : filtered.slice(0, 3)).map((work) => (
                  <RecommendCard type="button" key={work.id} onClick={() => setSelected(work)}>
                    <Poster style={artStyle(work)}><Pick>{t('✦ PICK')}</Pick></Poster>
                    <CardBody><CardTitle>{work.title}</CardTitle><CardText>{work.tagline}</CardText><Score>{work.score ? t('★ 평점 {score}').replace('{score}', work.score) : work.author}</Score></CardBody>
                  </RecommendCard>
                ))}
              </RecommendGrid>
            </Recommend>
            <Ranking>
              <SmallTitle>{t('↗ 실시간 TOP 10')}</SmallTitle><SmallSub>{t('작품 점수와 편집 순위를 반영합니다')}</SmallSub>
              <RankList>{ranked.map((work) => (
                <RankItem type="button" key={work.id} onClick={() => setSelected(work)}>
                  <RankNo $top={work.rank <= 3}>{work.rank}</RankNo><RankThumb style={artStyle(work)} />
                  <RankCopy><b>{work.title}</b><span>{genreLabel(work.genre)}</span></RankCopy>
                  <RankScore>{work.score ? `★ ${work.score}` : work.author || ''}</RankScore>
                </RankItem>
              ))}</RankList>
            </Ranking>
          </CurationGrid>
        </Curation>

        <Gallery>
          <SectionHead><div><H2>{t('전체 AI 작품')}</H2><Sub>{t('AI로 만든 새로운 작품을 한곳에서 만나보세요.')}</Sub></div></SectionHead>
          <GalleryGrid>{filtered.map((work) => (
            <GalleryCard type="button" key={work.id} onClick={() => setSelected(work)}>
              <GalleryPoster style={artStyle(work)}>{work.thumbnail ? null : <GalleryInitial>{work.title.slice(0, 1)}</GalleryInitial>}<Coming>{work.url ? t('영상 공개') : t('공개 예정')}</Coming></GalleryPoster>
              <CardBody><CardTitle>{work.title}</CardTitle><CardText>{work.tagline}</CardText><CardMeta>{work.year} · {genreLabel(work.genre)}{work.author ? ` · ${work.author}` : ''}{work.score ? ` · ★ ${work.score}` : ''}</CardMeta></CardBody>
            </GalleryCard>
          ))}</GalleryGrid>
        </Gallery>
        <Notice>{t('✦ 모든 작품은 AI로 제작된 창작물입니다. 실제 인물·사건과 관련이 없습니다.')}</Notice>
      </Main>

      {selected ? <Modal onClick={() => setSelected(null)}><Dialog role="dialog" aria-label={t('작품 정보')} onClick={(event) => event.stopPropagation()}><DialogCover style={artStyle(selected)}><Close type="button" aria-label={t('작품 정보 닫기')} title={t('작품 정보 닫기')} onClick={() => setSelected(null)}>×</Close><DialogTitle>{selected.title}</DialogTitle></DialogCover><DialogBody><LanguageSelect /><b>{selected.tagline}</b><p>{selected.url ? t('{author} 채널에서 공개한 작품입니다.').replace('{author}', () => selected.author) : t('앤츠캐스트 AI 작품관에서 소개하는 창작물입니다. 정식 공개와 함께 전체 이야기를 만나보세요.')}</p><Meta><span>{selected.year}</span><span>{genreLabel(selected.genre)}</span>{selected.author ? <span>{selected.author}</span> : null}{selected.score ? <span>★ {selected.score}</span> : null}</Meta>{selected.url ? <WatchLink href={selected.url} target="_blank" rel="noreferrer">{t('YouTube에서 작품 보기 ↗')}</WatchLink> : null}</DialogBody></Dialog></Modal> : null}
    </Page>
  );
}

const C = { bg: '#07111f', panel: '#101f35', card: '#17273f', line: 'rgba(151,177,220,.2)', text: '#f5f8ff', dim: '#98a9c5', blue: '#4d86ff', gold: '#ffd56b' };
const GlobalReset = createGlobalStyle`body { margin: 0; background: ${C.bg}; } * { box-sizing: border-box; } button, input { font: inherit; }`;
const Page = styled.div`min-height: 100vh; background: radial-gradient(circle at 90% 40%, rgba(32,168,150,.13), transparent 30%), ${C.bg}; color: ${C.text}; font-family: 'Pretendard-Regular','Noto Sans KR',sans-serif;`;
const Header = styled.header`position: sticky; top: 0; z-index: 20; min-height: 74px; padding: 12px 32px; display: flex; flex-wrap: wrap; align-items: center; gap: 28px; background: rgba(6,15,28,.91); border-bottom: 1px solid ${C.line}; backdrop-filter: blur(16px); @media(max-width:700px){padding:12px 16px;}`;
const Brand = styled(Link)`display:flex;align-items:center;gap:10px;color:${C.text};text-decoration:none;margin-right:auto;`;
const Mark = styled.span`width:34px;height:34px;border-radius:10px;display:grid;place-items:center;background:linear-gradient(135deg,#347dff,#7258f4);font-weight:900;`;
const BrandCopy = styled.span`display:flex;flex-direction:column;line-height:1.15;b{font-size:15px}span{font-size:11px;color:${C.dim};margin-top:3px}`;
const Nav = styled.nav`display:flex;gap:6px;padding:4px;border:1px solid ${C.line};border-radius:999px;background:rgba(255,255,255,.03);`;
const NavLink = styled(Link)`padding:9px 14px;border-radius:999px;color:${C.dim};text-decoration:none;font-size:13px;font-weight:700; @media(max-width:620px){&:last-child{display:none}}`;
const Active = styled(NavLink)`color:${C.text};background:rgba(77,134,255,.2);`;
const Main = styled.main`max-width:1440px;margin:0 auto;padding:30px 32px 54px;display:flex;flex-direction:column;gap:34px; @media(max-width:700px){padding:18px 16px 36px;gap:24px}`;
const Hero = styled.section`position:relative;overflow:hidden;min-height:360px;border-radius:28px;border:1px solid rgba(115,151,255,.6);box-shadow:0 28px 65px rgba(0,0,0,.3);display:flex;align-items:flex-end;`;
const HeroGlow = styled.div`position:absolute;inset:0;background:linear-gradient(90deg,rgba(4,10,20,.92),rgba(4,10,20,.62) 48%,rgba(4,10,20,.12));`;
const HeroContent = styled.div`position:relative;padding:38px;max-width:720px; @media(max-width:600px){padding:24px 20px}`;
const Badge = styled.span`display:inline-flex;padding:7px 13px;border:1px solid rgba(151,187,255,.4);border-radius:999px;background:rgba(68,126,245,.2);font-size:12px;font-weight:800;`;
const HeroTitle = styled.h1`font-size:clamp(36px,5vw,58px);line-height:1;margin:22px 0 14px;letter-spacing:-.05em;`;
const HeroText = styled.p`color:#d1ddf2;font-size:17px;line-height:1.65;margin:0 0 18px;`;
const Meta = styled.div`display:flex;gap:8px;flex-wrap:wrap;span{padding:6px 11px;border:1px solid ${C.line};border-radius:999px;background:rgba(255,255,255,.06);color:#d4def0;font-size:12px;font-weight:700}`;
const HeroButtons = styled.div`display:flex;gap:10px;margin-top:22px;`;
const Primary = styled.button`border:0;border-radius:11px;padding:13px 20px;background:${C.blue};color:white;font-weight:800;cursor:pointer;`;
const Secondary = styled(Primary)`background:rgba(255,255,255,.08);border:1px solid ${C.line};color:${C.dim};`;
const Toolbar = styled.div`display:flex;align-items:center;gap:14px;flex-wrap:wrap;`;
const Search = styled.input`width:min(320px,100%);height:46px;padding:0 18px;border:1px solid ${C.line};border-radius:999px;background:rgba(255,255,255,.04);color:${C.text};outline:none;&:focus{border-color:${C.blue}}`;
const Genres = styled.div`display:flex;gap:8px;flex-wrap:wrap;`;
const Chip = styled.button`padding:10px 15px;border-radius:999px;border:1px solid ${(p)=>p.$active?'rgba(102,157,255,.55)':C.line};background:${(p)=>p.$active?'rgba(77,134,255,.2)':'rgba(255,255,255,.035)'};color:${(p)=>p.$active?C.text:C.dim};font-size:13px;font-weight:700;cursor:pointer;`;
const Curation = styled.section`padding:24px;border:1px solid rgba(115,151,212,.32);border-radius:26px;background:linear-gradient(145deg,rgba(22,43,73,.9),rgba(10,22,39,.94));box-shadow:0 26px 58px rgba(0,0,0,.25);`;
const SectionHead = styled.div`display:flex;align-items:center;justify-content:space-between;gap:15px;margin-bottom:20px;`;
const H2 = styled.h2`font-size:25px;margin:0;letter-spacing:-.03em;`;
const Sub = styled.p`margin:7px 0 0;color:${C.dim};font-size:13px;`;
const CurationMark = styled.span`width:42px;height:42px;display:grid;place-items:center;border-radius:13px;background:rgba(77,134,255,.18);border:1px solid rgba(102,157,255,.35);color:#c6d9ff;font-size:20px;`;
const CurationGrid = styled.div`display:grid;grid-template-columns:minmax(0,1.4fr) minmax(300px,.6fr);gap:20px; @media(max-width:980px){grid-template-columns:1fr}`;
const Recommend = styled.div`min-width:0;`;
const Ranking = styled.div`padding-left:20px;border-left:1px solid ${C.line}; @media(max-width:980px){padding:20px 0 0;border-left:0;border-top:1px solid ${C.line}}`;
const SmallTitle = styled.h3`font-size:16px;margin:0;`;
const SmallSub = styled.p`font-size:12px;color:${C.dim};margin:7px 0 15px;`;
const RecommendGrid = styled.div`display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px; @media(max-width:650px){grid-template-columns:1fr}`;
const RecommendCard = styled.button`padding:0;overflow:hidden;text-align:left;border:1px solid ${C.line};border-radius:17px;background:${C.card};color:inherit;cursor:pointer;transition:.16s;&:hover{transform:translateY(-3px);border-color:rgba(102,157,255,.5)}`;
const Poster = styled.div`height:150px;position:relative;`;
const Pick = styled.span`position:absolute;left:10px;bottom:10px;padding:5px 8px;border-radius:999px;background:rgba(3,9,18,.75);font-size:10px;font-weight:900;letter-spacing:.08em;`;
const CardBody = styled.span`display:flex;flex-direction:column;gap:7px;padding:14px;`;
const CardTitle = styled.b`font-size:15px;`;
const CardText = styled.span`color:${C.dim};font-size:12px;line-height:1.5;min-height:36px;`;
const Score = styled.span`color:${C.gold};font-size:11px;font-weight:900;`;
const RankList = styled.div`display:flex;flex-direction:column;gap:6px;`;
const RankItem = styled.button`display:grid;grid-template-columns:30px 54px minmax(0,1fr) auto;align-items:center;gap:10px;width:100%;padding:7px;border:0;border-radius:12px;background:transparent;color:inherit;text-align:left;cursor:pointer;&:hover{background:rgba(255,255,255,.06)}`;
const RankNo = styled.span`font-size:18px;font-weight:900;text-align:center;color:${(p)=>p.$top?C.gold:C.dim};`;
const RankThumb = styled.span`width:54px;height:36px;border-radius:8px;`;
const RankCopy = styled.span`display:flex;flex-direction:column;min-width:0;gap:4px;b{font-size:13px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}span{font-size:11px;color:${C.dim}}`;
const RankScore = styled.span`font-size:12px;font-weight:900;color:${C.gold};max-width:88px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;`;
const Gallery = styled.section``;
const GalleryGrid = styled.div`display:grid;grid-template-columns:repeat(auto-fit,minmax(230px,1fr));gap:16px;`;
const GalleryCard = styled(RecommendCard)``;
const GalleryPoster = styled.div`height:150px;position:relative;display:grid;place-items:center;`;
const GalleryInitial = styled.span`font-size:68px;font-weight:900;color:rgba(255,255,255,.25);`;
const Coming = styled.span`position:absolute;top:10px;left:10px;padding:5px 9px;border-radius:999px;background:rgba(3,9,18,.72);font-size:11px;font-weight:800;`;
const CardMeta = styled.span`color:#bcc9de;font-size:11px;`;
const Notice = styled.p`margin:0;color:${C.dim};font-size:12px;`;
const Modal = styled.div`position:fixed;inset:0;z-index:50;display:grid;place-items:center;padding:20px;background:rgba(1,5,12,.75);backdrop-filter:blur(8px);`;
const Dialog = styled.div`width:min(640px,100%);overflow:hidden;border:1px solid ${C.line};border-radius:22px;background:${C.panel};box-shadow:0 30px 80px rgba(0,0,0,.5);`;
const DialogCover = styled.div`position:relative;height:230px;display:flex;align-items:flex-end;padding:28px;`;
const Close = styled.button`position:absolute;right:14px;top:14px;width:36px;height:36px;border:1px solid ${C.line};border-radius:50%;background:rgba(3,9,18,.65);color:white;font-size:22px;cursor:pointer;`;
const DialogTitle = styled.h2`font-size:32px;margin:0;`;
const DialogBody = styled.div`padding:24px;display:flex;flex-direction:column;gap:15px;b{font-size:17px}p{margin:0;color:${C.dim};line-height:1.75}`;
const WatchLink = styled.a`align-self:flex-start;padding:12px 17px;border-radius:10px;background:${C.blue};color:white;text-decoration:none;font-weight:800;&:hover{filter:brightness(1.08)}`;
